<template>
  <div class="bg-[#263042] border mx-4 border-zt-red rounded-zt">
    <div class="bg-[#263042] flex justify-between items-center rounded-t-zt">
      <div class="ml-2.5 text-[15px] py-2 font-semibold leading-normal whitespace-nowrap overflow-ellipsis overflow-hidden max-w-full xl:ml-[19px]">
        <template v-if="window.size.desktop">
          Uwaga! ŁAP <span class="text-zt-red">BONUS!</span>
        </template>
        <template class="overflow-ellipsis w-full" v-else>
          {{ data.title }}
        </template>
      </div>
      <div @click="closePopUp('Pop-up nowy: FAME 25 - Nie, dzięki (oraz krzyżyk)')"
           class="p-[7px] bg-zt-light cursor-pointer zt-hover rounded-zt mr-[13px]">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
          <path
              d="M1.15619 10.7499C1.10304 10.7502 1.05035 10.74 1.00115 10.7199C0.951945 10.6998 0.907192 10.6702 0.869457 10.6328C0.831605 10.5952 0.801561 10.5506 0.781059 10.5013C0.760556 10.4521 0.75 10.3994 0.75 10.346C0.75 10.2927 0.760556 10.2399 0.781059 10.1907C0.801561 10.1415 0.831605 10.0968 0.869457 10.0593L10.5618 0.366998C10.6378 0.290952 10.741 0.24823 10.8485 0.24823C10.956 0.24823 11.0592 0.290952 11.1352 0.366998C11.2113 0.443044 11.254 0.546184 11.254 0.653729C11.254 0.761274 11.2113 0.864414 11.1352 0.940459L1.44292 10.6328C1.40518 10.6702 1.36043 10.6998 1.31123 10.7199C1.26202 10.74 1.20934 10.7502 1.15619 10.7499Z"
              fill="white"/>
          <path
              d="M10.8478 10.7499C10.7947 10.7502 10.742 10.74 10.6928 10.7199C10.6436 10.6998 10.5988 10.6702 10.5611 10.6328L0.868768 0.940459C0.792722 0.864414 0.75 0.761273 0.75 0.653729C0.75 0.546184 0.792722 0.443043 0.868768 0.366998C0.944813 0.290952 1.04795 0.24823 1.1555 0.24823C1.26304 0.24823 1.36618 0.290952 1.44223 0.366998L11.1345 10.0593C11.1724 10.0968 11.2024 10.1415 11.2229 10.1907C11.2434 10.2399 11.254 10.2927 11.254 10.346C11.254 10.3994 11.2434 10.4521 11.2229 10.5013C11.2024 10.5506 11.1724 10.5952 11.1345 10.6328C11.0968 10.6702 11.0521 10.6998 11.0028 10.7199C10.9536 10.74 10.901 10.7502 10.8478 10.7499Z"
              fill="white"/>
        </svg>
      </div>
    </div>
    <div class="flex bg-zt-light/35 py-[6px] items-center px-2.5 xl:px-[19px]">
      <div>
        <a :href="data.link" class="no-default-style group">
					<img :src="data.thumbnail" class="w-[118px] h-[65px] group-hover:zt-hover lazy opacity-70 xl:w-[155px] xl:h-[87px]"
							 style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)" :alt="data.title"/>
				</a>
      </div>
      <div class="pl-2.5 w-full">
        <div>
          <a :href="data.link"
             class="no-default-style zt-hover hover:underline text-[11px] text-normal leading-normal text-ellipsis
                    line-clamp-4 xl:text-base xl:font-semibold">
            <template v-if="window.size.desktop">
              {{ data.title }}
            </template>
            <template v-else>
              {{ data.description }}
            </template>
          </a>
        </div>
        <div>
					<span>
						<svg xmlns="http://www.w3.org/2000/svg" class="inline" xmlns:xlink="http://www.w3.org/1999/xlink" width="10"
                 height="10" viewBox="0 0 10 10" fill="none">
              <rect width="10" height="10" fill="url(#pattern0)"/>
              <defs>
              <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
              <use xlink:href="#image0_10704_22615" transform="translate(-0.0217391) scale(0.0434783)"/>
              </pattern>
              <image id="image0_10704_22615" width="24" height="23"
                     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAXCAYAAAARIY8tAAAAAXNSR0IArs4c6QAAArFJREFUSImtlU9SG1cQh7/ueUqlTBZzhLlBxidAVMU4rIz3Fmj2Fo5OADrBACqvR6ADSF6pLKfK8gkCN1BOkNkkcZVmXnsxCAOSEDb+7eb1vN/3/vTrFu5Rmg1Cgo3dGmx6pS5GVEUkB7sAf1kUdtxOdqarPGRVoNv/8w3YEVhoRq4wLM3+BlC1EPRXoA4gQm82KzvLQAuANBuEzm0MriZPoOy0GjuT5TscRc5p04x9EQnBklbj+XAlIM1GUa0WfPSeUNV3Xr/6/XgxXtt8/eq3s0VQMABiM98+2Ps6T2/+6FyQeU9YlmzdNa+ORptmvnd3vJ3sTFuN7acgQxFNu/0P9QXA6fm4CdRVfaedbF8sO5J1KgqXmNlUxLI0G4S3AKocitBbtvKHqp1s5SI+MSNSffLHNeD0fNw0IzKTs/st1usqISZBIC+uASL2wsymrcazpdnyrTKTd2bEaTaKqiMSiYDLH2EOUJbFECAIgrqrkMRmvHuowcnZ+6Ob397/d9xOXuZfR37OYQb40H3LykRkCqAqhzfHndsYAteZ10628m5/jJlcAUxy1IfrAAd72z1g4R3cVZp9DGGGiOXVHahNtaotP0bucwwgElwogC/5BMTzx/Fof7QJ0Go8myiAajkEwvnjeIzSbBSJyKZIdZRakarHoSpv0mwUPQbgfnL7ZkSzWdm5BgAURZlggnNB9r3m3f77XbwdgT+Z94Zb5fr0fNQUCbKqgfzbvp3bDzBHM/DTVuP50/n4rXJ9sLfTA+uY0azVNv5Ks3G8zjjNBuHp+YcUZAB+WhT+5c340pbZ7Y/qZppJVUImItqbzfzlvIxX2fZL7Fy5C8E+WAj+pCj+P7q765U9GeY9wg6vQAsyIxeRCRQnq9rqvYC53mbj2DuLvCcGUJV/oLwsis8X6+7pCyGtKzxDfALCAAAAAElFTkSuQmCC"/>
              </defs>
            </svg>
					</span>
          <span class="text-[11px] font-light text-[#93A3BA] xl:text-xs">
						Zostało: <span class="font-semibold text-zt-red">{{ leftFormated }}</span>
					</span>
          <div class="only-desktop pt-[7px] leading-[18px]">
            <span class="text-xs font-light leading-normal text-[#EEEEE]">
            {{ data.description }}
          </span>
          </div>
        </div>
      </div>
      <div class="only-desktop">
        <div class="flex gap-x-5 xl:pl-3">
          <button @click="closePopUp('Pop-up stary - NIE, DZIĘKI')"
                  class="text-zt-red text-sm zt-hover border border-zt-red rounded-zt w-[120px]">
            NIE, DZIĘKI
          </button>
          <div v-if="preview" class="no-default-style cursor-pointer zt-hover text-center zt-button w-[120px]">
						SPRAWDŹ
					</div>
					<a v-else :href="data.link" @click="(event) => {
            event.preventDefault();
            closePopUp('Pop-up stary - SPRAWDŹ', data.link);
          }" class="no-default-style zt-hover text-center zt-button w-[120px]">SPRAWDŹ</a>
        </div>
      </div>
    </div>
    <div class="only-mobile pt-[9px]">
      <div class="flex gap-x-5 text-xs justify-center">
        <button @click="closePopUp('Pop-up nowy: FAME 25 - Nie, dzięki (oraz krzyżyk)')"
                class="text-zt-red zt-hover border border-zt-red rounded-zt h-[28px] w-[118px]">
          NIE, DZIĘKI
        </button>
        <a :href="data.link" @click="(event) => {
          event.preventDefault();
          closePopUp('Pop-up nowy: FAME 25 - Sprawdź', data.link);
        }" class="no-default-style zt-hover text-center h-[28px] bg-zt-red font-semibold rounded-zt grid place-items-center w-[118px]">SPRAWDŹ</a>
      </div>
    </div>
    <div class="bg-[#263042] h-[9px] w-full rounded-b-zt xl:h-2.5"></div>
  </div>
</template>


<script>

export default {
  name: 'OccasionalBonusPopUp',
  props: ['data', 'preview'],
  computed: {
    leftFormated() {
      const dt = this.DateTime.fromSQL(this.data.left_date);
      const today = this.DateTime.now();
      const diff = dt.diff(today, ['days', 'hours', 'minutes']).toObject();
      if (diff.days.toFixed(0) > 0) {
        if (diff.days.toFixed(0) === '1') {
          return diff.days.toFixed(0) + ' dzień';
        }
        return diff.days.toFixed(0) + ' dni';
      } else if (diff.hours.toFixed(0) > 0) {
        return diff.hours.toFixed(0) + ' godzin';
      } else {
        return diff.minutes.toFixed(0) + ' minut';
      }
    }
  },
  methods: {
    closePopUp(analyticName, href = null) {
      countClicks(analyticName).then(() => {
        if (href) {
          window.location.href = href;
        }
        this.$emit('close');
      });
    }
  },
}

</script>